/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var waitForJQuery = setInterval(function () {
	if (typeof $ != 'undefined') {
		console.log('loaded jquery')
		// place your code here.
		clearInterval(waitForJQuery);
		initApp();
	} else {
		console.log('waiting for jquery')
	}
}, 500);


function initApp() {
	
	$.fn.isInViewport = function() {
		if ($(this).length) {
			var elementTop = $(this).offset().top;
			var elementBottom = elementTop + $(this).outerHeight();
			
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
			
			return elementBottom > viewportTop && elementTop < viewportBottom;
		}
	};
	
	function initLazyCollectionImages() {
		var windowWidth = $(window).width();
		
		$('.ProductItem__Image--alternate').find('img').each(function () {
			var $this = $(this),
					imgSrc = $(this).data('flickity-lazyload');
			
			if (windowWidth > 900) {
				$this.attr('src', imgSrc);
			} else {
				var newSrc = imgSrc.replace('_1000x', '_300x');
				$this.attr('data-flickity-lazyload', newSrc)
			}
		});
	}
	
	function initCollectionCarousels() {
		var itemIds = [];
		$('.ProductItem').each(function(){
			var $id = $(this).attr('id');
			itemIds.push($id);
		});
		
		$(window).on('scroll', function() {
			$.each(itemIds, function( index, value ) {
				if ($('#' + value).isInViewport()) {
					var $product = $('#' + value);
					$product.find('.Image--lazyLoading').each(function(index){
						var $this = $(this),
                            newSrc = $this.data('flickity-lazyload');
						
						$this.attr('src', newSrc);
						$this.addClass('flickity-lazyloaded')
					})
				}
			});
		});
	}
	
	function initLazyCollectionProducts() {
		// Add second collection as a loading one
		$('.js-collection-section').each(function(index){
			var isLoading = $(this).hasClass('is-loading');
			console.log(index);
			if (isLoading) {
				if (index === 1) {
					$(this).parent().addClass('is-loading-section')
				} else {
					$(this).parent().addClass('is-hidden-section')
				}
			}
		})
	}
	
	function initLazyScrollProducts() {
		$(window).on('scroll', function() {
			if ($('.is-loading-section').isInViewport()) {
				var $this = $('.is-loading-section');
				console.log('reached the bottom');
				
				$this.find('.ProductItem__Image--initial').each(function(){
					var $img = $(this).find('img'),
							newSrc = $img.attr('data-src-2');
					$img.attr('src', newSrc)
				})
				
				
				$this.find('.js-collection-section').removeClass('is-loading');
				$this.removeClass('is-loading-section is-hidden-section');
				
				// Add loading state for next section
				setTimeout(function() {
					var $next = $this.next('.shopify-section');
					$next.addClass('is-loading-section');
					//$next.removeClass('is-hidden-section');
					$next.find('.js-collection-section').removeClass('is-loading');
				}, 1000)
			}
		})
	}

    function initCollectionSwitchSlide() {
      $('.ProductItem__Wrapper').on('touchend', '.flickity-prev-next-button', function(e){
        e.preventDefault();

        var $parent = $(this).parents('.ProductItem__Wrapper');
        $parent.find('.ProductItem__Image').each(function(){
          var $image = $(this).find('img'),
              newSrc = $image.attr('data-src-2');

          $image.attr('src', newSrc);
        })
      })
    }

    function setVideoEvents() {
      $('.ProductItem__ImageWrapper').on('click', function(e){
        var $this = $(this),
            isVideoItem = $this.find('.ProductItem__VideoWrapper').length > 0 ? true : false;

        if (isVideoItem) {
          var $videoEl = $this.find('video')
              $video = $videoEl.get(0),
              isVideoPaused = $video.paused;

          if (!isVideoPaused && !$videoEl.hasClass('is-active')) {
            e.preventDefault();
            $videoEl.addClass('is-active');
          } 
        }
      });
    }
	
	$('document').ready(function () {
		// initLazyCollectionImages();
		// initCollectionCarousels();
		initLazyCollectionProducts();
		initLazyScrollProducts();
        initCollectionSwitchSlide();
        setVideoEvents();
	})
}
